type AuthEvent = 'login' | 'logout' | 'refresh';

export const authBus = {
  emit(type: AuthEvent) {
    window.dispatchEvent(new CustomEvent(`auth:${type}`));
  },
  on(type: AuthEvent, handler: () => void) {
    const listener = () => handler();
    window.addEventListener(`auth:${type}`, listener);
    return () => window.removeEventListener(`auth:${type}`, listener);
  },
};
